export const Specs = {
  StorefrontResultsPageHeader: 'specs.premium.StorefrontResultsPageHeader',
  LoggedInMobileGate: 'specs.premium.domains.LoggedInMobileGate',
  LoggedInMobileConnectExperiment: 'loggedInMobileConnectAndAssignDomains',
  FunnelUxFixes: 'funnelUxFixes',
  StorefrontTldStrip: 'domainsStorefrontTldStrip',
} as const;

export type TSpecs = (typeof Specs)[keyof typeof Specs];

export type TSpecsExperiments = Record<TSpecs, boolean | string>;
